import React, { Component } from 'react';
import { Navbar } from 'react-bootstrap';
import { bootstrapUtils } from 'react-bootstrap/lib/utils';
import PropTypes from 'prop-types';

bootstrapUtils.addStyle(Navbar, 'custom');

export default class Navigation extends Component {
  render() {
    return (
      <div>
        <style type="text/css">{`
                    .navbar-custom {
                        background-color: #404040;
                        color: #ffffff;
                        border-radius: 0;
                    }
                    .navbar-custom .navbar-nav > li > a {
                        color: #fff;
                        margin: 10px;
                        opacity: 0.7;
                    }
                    .navbar-custom .navbar-nav > .active > a {
                        color: #ffffff;
                        background-color: #00A6C9 !important;
                        opacity: 1;
                    }
                    .navbar-custom .navbar-nav > .active > a:hover {
                        background-color: #00A6C9;
                        opacity: 1;
                    }
                    .navbar-custom .navbar-nav > li > a:hover,
                    .navbar-custom .navbar-nav > li > a:focus,
                    .navbar-custom .navbar-nav > .open >a {
                        background-color: transparent;
                        opacity: 1;
                        transition: opacity .3s ease;
                    }
                    .navbar-custom .navbar-brand {
                        color: #eeeeee;
                    }
                    .navbar-custom .navbar-toggle {
                        background-color: #eeeeee;
                    }
                    .navbar-custom .icon-bar {
                        background-color: #00A6C9;
                    }
                `}</style>
        <Navbar fluid collapseOnSelect bsStyle="custom">
          {this.props.children}
        </Navbar>
      </div>
    );
  }
}

Navigation.propTypes = {
  children: PropTypes.node.isRequired
};



// WEBPACK FOOTER //
// ./src/containers/Navigation.js